"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentSchema = void 0;
const z = require("zod");
const package_data_adjudication_types_1 = require("../../../PackageDataAdjudication/package-data-adjudication.types");
const experiment_metadata_1 = require("./experiment-metadata");
const experiment_scores_1 = require("./experiment-scores");
const experiment_tags_1 = require("./experiment-tags");
const scored_ai_task_1 = require("./scored-ai-task");
exports.ExperimentSchema = z.object({
    id: z.string(),
    userName: z.string(),
    datasetId: z.string(),
    task: z.nativeEnum(scored_ai_task_1.ScoredAiTask),
    description: z.string(),
    overallScores: experiment_scores_1.ScoresSchema.optional(),
    metadata: experiment_metadata_1.ExperimentMetadataSchema,
    createdAt: z.date().optional(),
    tags: experiment_tags_1.ExperimentTagsSchema,
    assessmentStatus: package_data_adjudication_types_1.ExperimentAssessmentStatusSchema,
    assessedAt: z.date().optional(),
    dispatchedAt: z.date().optional(),
});
//# sourceMappingURL=experiment.js.map